import { SMART_TASK_PROPERTY_NAME } from './constants';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import Item from 'owa-service/lib/contract/Item';

/**
 *  Returns smart task extended property from the email message item
 */
export default function getSmartTaskPropertyFromItem(item: Item): ExtendedPropertyType {
    let smartTaskProp: ExtendedPropertyType = null;
    if (item) {
        const extendedProperties = item.ExtendedProperty;
        if (extendedProperties) {
            extendedProperties.some(prop => {
                if (prop.ExtendedFieldURI.PropertyName == SMART_TASK_PROPERTY_NAME) {
                    smartTaskProp = prop;
                    return true;
                }
                return false;
            });
        }
    }
    return smartTaskProp;
}
